// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CatalogHarvesterShort } from "./CatalogHarvesterShort";
import {
  CatalogHarvesterShortFromJSON,
  CatalogHarvesterShortFromJSONTyped,
  CatalogHarvesterShortToJSON,
  CatalogHarvesterShortToJSONTyped,
} from "./CatalogHarvesterShort";

/**
 *
 * @export
 * @interface PageCatalogHarvesterShort
 */
export interface PageCatalogHarvesterShort {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<CatalogHarvesterShort>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageCatalogHarvesterShort interface.
 */
export function instanceOfPageCatalogHarvesterShort(
  value: object
): value is PageCatalogHarvesterShort {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageCatalogHarvesterShortFromJSON(json: any): PageCatalogHarvesterShort {
  return PageCatalogHarvesterShortFromJSONTyped(json, false);
}

export function PageCatalogHarvesterShortFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageCatalogHarvesterShort {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(CatalogHarvesterShortFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageCatalogHarvesterShortToJSON(json: any): PageCatalogHarvesterShort {
  return PageCatalogHarvesterShortToJSONTyped(json, false);
}

export function PageCatalogHarvesterShortToJSONTyped(
  value?: PageCatalogHarvesterShort | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(CatalogHarvesterShortToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
